import PropTypes from "prop-types";
import { NavMenuItemBase } from ".";

const propTypes = {
  icon: PropTypes.object,
  onClick: PropTypes.func,
  title: PropTypes.string,
  classname: PropTypes.string,
};

function NavMenuItemSimple({ onClick, title, icon, className }) {
  return (
    <NavMenuItemBase
      icon={icon}
      title={title}
      onClick={onClick}
      className={className}
    />
  );
}

NavMenuItemSimple.propTypes = propTypes;
export default NavMenuItemSimple;
